var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  stroke: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.9 20.8v-2.2a4.2 4.2 0 0 0-1-2.7 4.5 4.5 0 0 0-2.4-1.5m-3.4 6.3v-2.1c0-1.2-.4-2.3-1.3-3a4.6 4.6 0 0 0-3.2-1.4h-9a4.6 4.6 0 0 0-3.2 1.3 4.3 4.3 0 0 0-1.3 3v2.2M18 1.4c1 .2 1.8.8 2.4 1.5a4.2 4.2 0 0 1 0 5.3A4.5 4.5 0 0 1 18 9.8m-7.9.1c2.5 0 4.5-2 4.5-4.3 0-2.4-2-4.3-4.5-4.3S5.6 3.1 5.6 5.5s2 4.3 4.5 4.3Z",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgPeople;